import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { IAuthenticationService } from '@nimbus-library/features/authentication/services/i-authentication.service';
import { CompanionApiClient } from '@nimbus-library/features/companion-chat/services/api/companion.api-client';
import {
  CompanionConversationMessageModel,
  CompanionConversationModel,
  ConversationMessagesResponseModel,
  ConversationsResponseModel,
} from '@nimbus-library/features/companion-chat/models/companion-conversation.model';

@Injectable({ providedIn: 'root' })
export class CompanionService {
  private readonly conversationUpdated = new Subject<void>();
  public readonly conversationUpdated$ = this.conversationUpdated.asObservable();

  public constructor(
    private readonly apiClient: CompanionApiClient,
    private readonly authenticationService: IAuthenticationService,
  ) {}

  public notifyConversationUpdated(): void {
    this.conversationUpdated.next();
  }

  // GET

  public getConversations(pageSize: number, skip?: string, search?: string): Observable<ConversationsResponseModel> {
    const { tenantId, userId } = this.authenticationService.getUserInfo();
    return search
      ? this.apiClient.searchConversations(tenantId, userId, search, pageSize, skip)
      : this.apiClient.getConversations(tenantId, userId, pageSize, skip);
  }

  public getConversationMessages(conversationId: string, pageSize: number, skip?: string): Observable<ConversationMessagesResponseModel> {
    const { tenantId, userId } = this.authenticationService.getUserInfo();
    return this.apiClient.getConversationMessages(tenantId, conversationId, userId, pageSize, skip);
  }

  // POST

  public postConversation(model: CompanionConversationMessageModel, conversationId?: string): Observable<CompanionConversationModel> {
    const { tenantId, userId } = this.authenticationService.getUserInfo();
    return this.apiClient.postConversation(tenantId, userId, model, conversationId);
  }

  // PATCH

  public patchConversationTitle(conversationId: string, title: string): Observable<void> {
    const { tenantId, userId } = this.authenticationService.getUserInfo();
    return this.apiClient.patchConversationTitle(tenantId, userId, conversationId, title);
  }

  // DELETE

  public deleteConversation(conversationId?: string): Observable<void> {
    const { tenantId, userId } = this.authenticationService.getUserInfo();
    return this.apiClient.deleteConversation(tenantId, userId, conversationId);
  }
}
